import { BaseFeaturedSectionRouteStore } from "administration/naki-mobile/stores";

class NakiMobileHandheldPinkFeaturedSectionRouteStore extends BaseFeaturedSectionRouteStore {
    constructor(rootStore) {
        super(rootStore);
    }
}

export default NakiMobileHandheldPinkFeaturedSectionRouteStore;
